import { CssBaseline as JoyCssBaseline } from '@mui/joy';
import { CssVarsProvider as JoyCssVarsProvider } from '@mui/joy/styles';
import CssBaseline from '@mui/material/CssBaseline';
import {
  Experimental_CssVarsProvider as MaterialCssVarsProvider,
  THEME_ID as MATERIAL_THEME_ID,
} from '@mui/material/styles';
import { Worker } from '@react-pdf-viewer/core';
import '@react-pdf-viewer/core/lib/styles/index.css';
import { StrictMode } from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from 'react-query';
import { Provider } from 'react-redux';

import { BugsnagProvider, BugsnagWrapper } from 'bugsnag';
import { AppEnv } from 'core/enums';
import { Theme } from 'coreOld/components';
import { APP_ENV, PHPSESSID } from 'global';
import { Router } from 'router/components';
import { store } from 'store';
import { materialTheme } from 'theme/materialTheme';
import { theme } from 'theme/theme';

import { setupNewRelic } from './newRelic';
import reportWebVitals from './reportWebVitals';
import './i18n';
import './index.css';

// Set up New Relic Browser Agent
setupNewRelic();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

const pdfWorkerUrl = 'https://unpkg.com/pdfjs-dist@3.4.120/build/pdf.worker.min.js';

function App() {
  if (APP_ENV === AppEnv.DEVELOPMENT) {
    document.cookie = `PHPSESSID=${PHPSESSID}; Max-Age=2600000; Secure ; SameSite= None`;
  }

  return (
    <StrictMode>
      <BugsnagProvider>
        <BugsnagWrapper>
          <QueryClientProvider client={queryClient}>
            <Provider store={store}>
              <Theme>
                <MaterialCssVarsProvider theme={{ [MATERIAL_THEME_ID]: materialTheme }}>
                  <CssBaseline enableColorScheme />
                  <JoyCssVarsProvider theme={theme}>
                    <JoyCssBaseline />
                    <Worker workerUrl={pdfWorkerUrl}>
                      <Router />
                    </Worker>
                  </JoyCssVarsProvider>
                </MaterialCssVarsProvider>
              </Theme>
            </Provider>
          </QueryClientProvider>
        </BugsnagWrapper>
      </BugsnagProvider>
    </StrictMode>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(<App />);

reportWebVitals();
